// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-g5qgGMUproXDwgWU5lU6"};